import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const parseQuery = (search) => {
  const entries = new URLSearchParams(search).entries();
  const params = {};
  for (const [key, value] of entries) {
    params[key] = JSON.parse(JSON.stringify(value));
  }
  return params;
};

const stringifyQuery = (query) => {
  return new URLSearchParams(query).toString();
};

const hasParams = (search) => {
  return search.indexOf('=') > -1;
};

const getQuery = (search, defaultQuery) => React.useCallback(() => {
  return hasParams(search) ? { ...defaultQuery, ...parseQuery(search) } : defaultQuery;
}, [search, defaultQuery]);

export const useQuery = (defaultQuery, method = 'push') => {
  const history = useHistory();
  const { search, pathname, hash } = useLocation();
  const [query, setQuery] = React.useState(getQuery(search, defaultQuery));

  const setQueryValue = (value) => {
    const search = stringifyQuery(value);
    setQuery(value);
    history[method](pathname + '?' + search + hash);
  };

  return [
    query,
    setQueryValue
  ];
};
